<div class="onboarding-v2">
  <canvas #graphCanvas class="onboarding-v2__graph-canvas"></canvas>
  <div class="onboarding-v2__backdrop onboarding-v2__backdrop--first"></div>
  <div class="onboarding-v2__backdrop onboarding-v2__backdrop--second"></div>

  <div class="onboarding-v2__content">
    <section class="onboarding-v2__hero">
      <img class="onboarding-v2__logo" src="/logo.png" alt="Kaspacom Wallet" />

      <div class="onboarding-v2__hero-copy">
        <h1 class="typo-title-1 text-light">The Official KaspaCom Wallet</h1>
        <p class="typo-text-2 text-medium">
          Set up or connect your wallet in a fast, secure, mobile-optimized
          experience.
        </p>
      </div>

      <div class="onboarding-v2__hero-actions">
        <kc-button
          [text]="'More Info'"
          [variant]="'secondary'"
          (buttonClick)="openPublicWalletPage()"
        />
      </div>

      <div class="onboarding-v2__social-links">
        <a
          href="https://github.com/KASPACOM/kaspacom-web-wallet"
          target="_blank"
          rel="noopener noreferrer"
          class="onboarding-v2__social-link"
          aria-label="GitHub"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.167 22 16.418 22 12c0-5.523-4.477-10-10-10z"
              fill="currentColor"
            />
          </svg>
        </a>
        <a
          href="https://x.com/KaspaCom"
          target="_blank"
          rel="noopener noreferrer"
          class="onboarding-v2__social-link"
          aria-label="X (Twitter)"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              fill="currentColor"
            />
          </svg>
        </a>
        <a
          href="https://t.me/KaspaComOfficial"
          target="_blank"
          rel="noopener noreferrer"
          class="onboarding-v2__social-link"
          aria-label="Telegram"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.13-.31-1.09-.66.02-.18.27-.36.75-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.44.08-.01.27-.02.39.03.1.05.13.12.15.17.01.05.02.17.01.26z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
    </section>

    <section class="onboarding-v2__device">
      <div class="onboarding-v2__device-frame">
        <div class="onboarding-v2__notch"></div>

        <div class="onboarding-v2__panel">
          <header class="onboarding-v2__panel-header">
            <div class="onboarding-v2__panel-heading">
              @if (isWelcome() || shouldShowLogin()) {
                <img
                  class="onboarding-v2__panel-logo"
                  src="/logo.png"
                  alt="KaspaCom Wallet logo"
                />
              }
              <h2 class="typo-title-3 text-light">{{ panelCopy().title }}</h2>
            </div>

            @if (!shouldShowLogin() && !isWelcome()) {
              <kc-button
                class="onboarding-v2__restart"
                [text]="'Start Over'"
                [variant]="'link'"
                (buttonClick)="resetFlow()"
              />
            }
          </header>

          <p class="typo-text-2 text-medium onboarding-v2__panel-description">
            {{ panelCopy().description }}
          </p>

          <div
            class="onboarding-v2__panel-content"
            [class.onboarding-v2__panel-content--transitioning]="
              !shouldShowLogin() && isTransitioning()
            "
          >
            @if (shouldShowLogin()) {
              <form
                class="onboarding-v2__login-form"
                [formGroup]="loginForm"
                (ngSubmit)="onSubmit()"
              >
                <div class="onboarding-v2__login-field">
                  <kc-input
                    formControlName="password"
                    [placeholder]="'Password'"
                    [type]="passwordType()"
                    [isValid]="!isInvalid('password')"
                    [isDisabled]="isSubmitting()"
                  >
                    <div
                      (click)="!isSubmitting() && togglePwVisibility()"
                      [class]="
                        isSubmitting()
                          ? 'onboarding-v2__visibility-toggle onboarding-v2__visibility-toggle--disabled'
                          : 'onboarding-v2__visibility-toggle clickable'
                      "
                      rightSideSlot
                    >
                      <kc-icon
                        iconClass="{{ passwordIcon() }}"
                        [size]="'xs'"
                        [class]="isSubmitting() ? 'disabled-icon' : ''"
                      />
                    </div>
                  </kc-input>
                  @if (isInvalid("password") && getPasswordError()) {
                    <span class="kc-input-error-text">{{
                      getPasswordError()
                    }}</span>
                  }
                </div>

                <div class="onboarding-v2__login-actions">
                  <kc-button
                    [isDisabled]="!loginForm.valid || isSubmitting()"
                    (buttonClick)="loginForm.valid && onSubmit()"
                    [isFullWidth]="true"
                    [isLoading]="isSubmitting()"
                    [text]="'Login'"
                  />

                  <kc-button
                    class="onboarding-v2__delete-trigger kc-button-danger"
                    [variant]="'secondary'"
                    [isFullWidth]="true"
                    [isDisabled]="isSubmitting()"
                    (buttonClick)="openDeleteWalletDialog()"
                    [text]="'Delete Wallet'"
                  />
                </div>
              </form>
            } @else {
              @switch (onboardingStep()) {
                @case (OnboardingStep.WELCOME) {
                  <div class="onboarding-v2__welcome">
                    <div class="onboarding-v2__welcome-visual">
                      <img
                        src="/svgs/wallet.svg"
                        class="onboarding-v2__welcome-illustration"
                        alt="Wallet illustration"
                      />
                    </div>

                    <div class="onboarding-v2__actions">
                      <kc-button
                        [text]="'Create New Wallet'"
                        [isFullWidth]="true"
                        (buttonClick)="createNewWallet()"
                      />

                      <kc-button
                        [text]="'Connect Existing Wallet'"
                        [variant]="'secondary'"
                        [isFullWidth]="true"
                        (buttonClick)="startExistingWallet()"
                      />
                    </div>
                  </div>
                }
                @case (OnboardingStep.IMPORT_EXISTING_WALLET) {
                  <app-import-existing-flow class="onboarding-v2__flow" />
                }
                @case (OnboardingStep.NEW_WALLET) {
                  <app-new-wallet-flow class="onboarding-v2__flow" />
                }
              }
            }
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Delete Wallet Modal - Rendered at root level to avoid overflow clipping -->
  @if (showDeleteConfirmation()) {
    <div
      class="onboarding-v2__delete-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="deleteWalletDialogTitle"
    >
      <div class="onboarding-v2__delete-dialog">
        <div class="onboarding-v2__delete-warning">
          <h2
            id="deleteWalletDialogTitle"
            class="typo-title-3 text-light onboarding-v2__delete-title"
          >
            Are you sure you want to delete your wallet?
          </h2>
          <p class="typo-text-2 text-medium onboarding-v2__delete-message">
            You are about to delete your wallet. Please make sure you have
            exported your wallet or saved your wallets separately before
            deleting.
          </p>
          <div class="onboarding-v2__delete-highlight">
            <kc-icon
              iconClass="icon-info"
              [size]="'sm'"
              color="var(--warning-color, #FFB800)"
            />
            <span
              class="typo-text-3 text-light onboarding-v2__delete-highlight-text"
            >
              Without your seed phrase or backup, you will permanently lose
              access to your funds.
            </span>
          </div>
        </div>

        <div class="onboarding-v2__delete-confirmation">
          <p class="typo-text-3 text-medium onboarding-v2__delete-prompt">
            Type <strong>{{ deleteConfirmationPhrase }}</strong> to confirm.
          </p>
          <kc-input
            class="onboarding-v2__delete-input"
            [placeholder]="deleteConfirmationPhrase"
            [ngModel]="deleteConfirmationInput()"
            [isDisabled]="isDeletingWallet()"
            (valueChange)="onDeleteConfirmationInputChange($any($event))"
          />
        </div>

        <div class="onboarding-v2__delete-actions">
          <kc-button
            [text]="'Cancel'"
            [variant]="'secondary'"
            [isFullWidth]="true"
            (buttonClick)="closeDeleteWalletDialog()"
            [isDisabled]="isDeletingWallet()"
          />

          <kc-button
            class="kc-button-danger"
            [text]="'Delete Wallet'"
            [variant]="'secondary'"
            [isFullWidth]="true"
            [isLoading]="isDeletingWallet()"
            [isDisabled]="isDeletingWallet() || !isDeleteConfirmationValid()"
            (buttonClick)="confirmDeleteWallet()"
          />
        </div>
      </div>
    </div>
  }
</div>
